module.exports = __webpack_public_path__ + "media/images/vglist-opengraph-image-f9de424b09a4289a2ba859fec7dfb7f2.png";